const Footer = () => {
  return (
    <p className="d-flex justify-content-center clearfix mb-0">
      <span className="float-md-left d-block d-md-inline-block mt-25 ml-2">
        COPYRIGHT ©{new Date().getFullYear()} M&G
      </span>
    </p>
  )
}

export default Footer
